import React, { FC } from 'react';

import { fc } from 'i18n';
import Checkbox from 'core/react/general/form/Checkbox';

import styles from './styles.module.css';

interface IOccupancyHeaderProps {
  isSortedByZone: boolean;
  toggleSortByZone: (value: boolean) => void;
}

export const OccupancyHeader: FC<IOccupancyHeaderProps> = ({ isSortedByZone, toggleSortByZone }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{fc('Outstanding Breakdown')}</div>
      <div className={styles.switcher}>
        <Checkbox value={isSortedByZone} onChange={toggleSortByZone} />
        <div className={styles.label}>{fc('By Zone')}</div>
      </div>
    </div>
  );
};
